module.exports = __webpack_public_path__ + "assets/security-2-b48bbd92330a2e5e2d3a994d1f5b60f0.svg";